/* tslint:disable */
/* eslint-disable */
/**
 * Dialpad Contact API
 * API to fetch call center groups with specific filters.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface OperatorGroup
 */
export interface OperatorGroup {
  /**
   *
   * @type {string}
   * @memberof OperatorGroup
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof OperatorGroup
   */
  groupId: number;
  /**
   *
   * @type {string}
   * @memberof OperatorGroup
   */
  key?: string;
  /**
   *
   * @type {string}
   * @memberof OperatorGroup
   */
  displayName?: string;
  /**
   *
   * @type {boolean}
   * @memberof OperatorGroup
   */
  canEdit?: boolean;
}

/**
 * Check if a given object implements the OperatorGroup interface.
 */
export function instanceOfOperatorGroup(value: object): value is OperatorGroup {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('groupId' in value) || value['groupId'] === undefined) return false;
  return true;
}

export function OperatorGroupFromJSON(json: any): OperatorGroup {
  return OperatorGroupFromJSONTyped(json, false);
}

export function OperatorGroupFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OperatorGroup {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    groupId: json['group_id'],
    key: json['key'] == null ? undefined : json['key'],
    displayName:
      json['display_name'] == null ? undefined : json['display_name'],
    canEdit: json['can_edit'] == null ? undefined : json['can_edit'],
  };
}

export function OperatorGroupToJSON(value?: OperatorGroup | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    group_id: value['groupId'],
    key: value['key'],
    display_name: value['displayName'],
    can_edit: value['canEdit'],
  };
}
